import React from "react";
import { Text, Tabs } from "@mantine/core";

import { Page } from "../layout/page";
import _ from "lodash";
import DashboardManagement from "./dashboardManagement";
import DashboardConsultant from "./dashboardConsultant";
import { useAuthUser } from "react-auth-kit";
import { useTranslation } from "react-i18next";
import { dashboardViewOptions } from "../data/dashboardViews";

const dashboardViewComponents = {
  DM: DashboardManagement,
  DC: DashboardConsultant,
  DO: DashboardManagement,
};

const dashboardViews = dashboardViewOptions.map((option) => ({
  ...option,
  component: dashboardViewComponents[option.id],
}));

function Dashboard() {
  const auth = useAuthUser();
  const { userRole } = auth();

  const grantedDashboards = userRole?.dashboards || userRole?.dashBoards || [];
  const availableDashboardViews = dashboardViews.filter((v) =>
    grantedDashboards.includes(v.id)
  );

  const NO_DASHBOARD_VIEW_MSG =
    "There are no dashboard views for the user role";

  const { t } = useTranslation();

  return (
    <Page title={"Dashboard"}>
      {_.isEmpty(availableDashboardViews) && (
        <Text> {NO_DASHBOARD_VIEW_MSG}</Text>
      )}
      {!_.isEmpty(availableDashboardViews) && (
        <Tabs defaultValue={availableDashboardViews[0].id}>
          <Tabs.List mb={"xl"}>
            {availableDashboardViews.map((v) => (
              <Tabs.Tab key={v.id} value={v.id}>
                {t(v.label)}
              </Tabs.Tab>
            ))}
          </Tabs.List>

          {availableDashboardViews.map((v) => (
            <Tabs.Panel key={v.id} value={v.id}>
              <v.component />
            </Tabs.Panel>
          ))}
        </Tabs>
      )}
    </Page>
  );
}

export default Dashboard;
